var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"container",attrs:{"id":"scan"}},[_c('img',{attrs:{"src":_vm.landingPage,"alt":""}}),_c('div',{staticClass:"fix-bottom"},[_c('vanButton',{staticClass:"registered-btn",on:{"click":_vm.goToregister}},[_vm._v(_vm._s(_vm.$t('app.label.registration')))])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }